
<div class="assistant-anchor">
  <ngt-button class="relative open-button" [class.visible]="!isOpen()" styling="tertiary" shape="round" (ngtClick)="open()">
    <img class="absolute" src="assets/images/assistant.png" alt="assistant" style="width: 56px; height: 56px;">
  </ngt-button>

  <div class="assistant-container" [class.open]="isOpen()" [class.drag-over]="dragOver()" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
    <div class="title-bar">
      <div class="title">{{ ('personalAssistant' | translate)() }}</div>
      <ngt-button styling="tertiary" shape="round" matIcon="close" (ngtClick)="close()">
        <img class="absolute" src="assets/images/assistant.png" alt="assistant" style="width: 56px; height: 56px;">
      </ngt-button>
    </div>
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label><mat-icon>chat</mat-icon></ng-template>
          <div class="chat">
            @for (message of messages(); track $index) {
              @switch (message.type) {
                @case ('standard') {
                  @if (message.content) {
                    <tps-assistant-message [role]="message.role" [messageContent]="message.content" />
                  }
                }
                @case ('component') {
                  <div [ngComponentOutlet]="message.component" [ngComponentOutletInputs]="{ data: message.data, update: getUpdateHandler(message) }"></div>
                }
              }
            }
          </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label><mat-icon>task</mat-icon></ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label><mat-icon>history</mat-icon></ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label><mat-icon>timer</mat-icon></ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label><mat-icon>forum</mat-icon></ng-template>
      </mat-tab>
    </mat-tab-group>
      @if (uploadedFiles().length) {
        <div class="uploaded-files-row">
          @for (file of uploadedFiles(); track file.name + '_' + $index) {
            <ngt-chip removable (remove)="removeUploadedFile($index)">{{ file.name }}</ngt-chip>
          }
        </div>
      }
      <div class="input-bar">
        <ngt-button styling="tertiary" shape="round" matIcon="add" [matMenuTriggerFor]="menu" />
        <ngt-input-field [label]="('questionOrSearch' | translate)()" [(value)]="newMessage" width="max" (keydown)="handleKeydownEvent($event)" />
        <ngt-button styling="secondary" [disabled]="newMessage() == ''" matIcon="send" (ngtClick)="sendMessage()" />

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openBrowseFiles()">
            <mat-icon>upload</mat-icon>
            {{ ('browseFiles' | translate)() }}
          </button>
        </mat-menu>

        <input #fileInput type="file" class="hidden-file-input" multiple (change)="onFilesSelected($event)">
      </div>
  </div>
</div>
